import React from 'react';
import { Text, TextField } from '@radix-ui/themes';

export default function ProjectYearField({ value, onChange, onBlur, error }) {
  return (
    <>
      <TextField.Root
        size="2"
        id="year"
        name="year"
        type="number"
        min="1000"
        max="9999"
        step="1"
        required
        aria-label="분류 연도"
        aria-describedby={error ? 'project-year-error' : undefined}
        aria-invalid={Boolean(error)}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder="예: 2026"
        style={{ maxWidth: '180px' }}
      />
      {error && (
        <Text as="p" id="project-year-error" mt="1" className="font-error body3">
          {error}
        </Text>
      )}
    </>
  );
}
